import { Button, Text } from '@/components';
import { BigCalculator, formatPercentage } from '@/utils';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import type { FC } from 'react';
import { useReactFlow, useViewport } from 'reactflow';

const TICK_DURATION = 0.05;

export const ScalingButtonGroup: FC = () => {
  const reactFlow = useReactFlow();
  const { zoom } = useViewport();

  const handleZoom = (operation: 'zoomIn' | 'zoomOut') => {
    reactFlow[operation]({
      duration: BigCalculator[operation === 'zoomIn' ? 'add' : 'subtract'](
        zoom,
        TICK_DURATION,
      ),
    });
  };

  return (
    <Button.Group>
      <Button disabled style={{ background: 'white', cursor: 'default' }}>
        <Text
          weight="regular"
          text={formatPercentage(zoom, { maximumFractionDigits: 0 })}
        />
      </Button>
      <Button
        onClick={() => {
          handleZoom('zoomIn');
        }}
      >
        <PlusOutlined />
      </Button>
      <Button
        disabled={zoom <= TICK_DURATION}
        onClick={() => {
          handleZoom('zoomOut');
        }}
      >
        <MinusOutlined />
      </Button>
    </Button.Group>
  );
};
